// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notification {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex: 1 1;
  height: 100%;
  box-sizing: border-box;
  overflow: scroll;
}
.notification-products {
  margin: 0;
}
.notification-operator {
  display: flex;
  gap: 1em;
  padding-left: 0.5em;
  color: #777776;
  font-size: 0.9em;
}
.notification-operator-container {
  padding-left: 0.5em;
}
.notification-operator span:not(:first-child) {
  margin-left: -0.7em;
}
.notification-operator-feedback {
  color: #777776;
  font-size: 0.8em;
  margin-left: 1em !important;
}
.notification-operator-selected {
  color: black;
  font-weight: 500;
}
.notification-title {
  font-size: 1.5em;
  font-weight: bold;
}
.notification-container {
  flex: 1 1;
  margin-top: 2em;
  margin-inline: 2em;
  padding: 2em;
  border-radius: 1em;
  background-color: #fff;
}
.notification-form {
  display: flex;
  flex-direction: column;
}
.notification-form-layout {
  display: flex;
  justify-content: space-evenly;
  align-items: flex-start;
  flex-wrap: wrap;
  flex-direction: column;
}

.notification-radio-group {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
}
.notification-radio-group .form-radio-group:last-child {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1em;
  flex-wrap: wrap;
  overflow: scroll;
  max-height: 8em;
}

.notification-option-label {
  margin-right: 0.5em;
}

.info-badge, .warning-badge, .danger-badge {
  background-color: rgb(224, 224, 224) !important;
}

.info-badge {
  color: rgb(0, 0, 255);
  border: 1px solid rgb(0, 0, 255);
}

.warning-badge {
  color: rgb(238, 255, 0);
  border: 1px solid rgb(238, 255, 0);
}

.danger-badge {
  color: rgb(255, 8, 0);
  border: 1px solid rgb(255, 8, 0);
}`, "",{"version":3,"sources":["webpack://./src/components/views/notifications/notificationForm/notificationForm.scss","webpack://./src/sass/globals/mixins.scss","webpack://./src/sass/globals/globals.scss"],"names":[],"mappings":"AAGA;ECFC,aAAA;EACA,uBDEc;ECDd,uBDCsB;EACtB,SAAA;EACA,YAAA;EACA,sBAAA;EACA,gBAAA;AAAD;AAEC;EACC,SAAA;AAAF;AAGC;EACC,aAAA;EACA,QAAA;EACA,mBAAA;EACA,cEXU;EFYV,gBAAA;AADF;AAGE;EACC,mBAAA;AADH;AAIE;EACC,mBAAA;AAFH;AAKE;EACC,cEvBS;EFwBT,gBAAA;EACA,2BAAA;AAHH;AAME;EACC,YAAA;EACA,gBAAA;AAJH;AAQC;EACC,gBAAA;EACA,iBAAA;AANF;AASC;EACC,SAAA;EACA,eAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,sBEhDM;AFyCR;AAUC;EACC,aAAA;EACA,sBAAA;AARF;AAUE;EC1DD,aAAA;EACA,6BD0DgB;ECzDhB,uBDyD8B;EAC5B,eAAA;EACA,sBAAA;AANH;;AAWA;EC5DC,aAAA;EACA,sBAAA;EACA,2BD2DoB;EC1DpB,uBD0DgC;EAChC,WAAA;AALD;AAOC;EACC,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;AALF;;AAUC;EACC,mBAAA;AAPF;;AAWA;EACC,+CAAA;AARD;;AAWA;EACC,qBAAA;EACA,gCAAA;AARD;;AAWA;EACC,uBAAA;EACA,kCAAA;AARD;;AAWA;EACC,qBAAA;EACA,gCAAA;AARD","sourcesContent":["@import '../../../../sass/globals/globals.scss';\n@import '../../../../sass/globals/mixins.scss';\n\n.notification {\n\t@include flex(center, flex-start);\n\tflex: 1;\n\theight: 100%;\n\tbox-sizing: border-box;\n\toverflow: scroll;\n\n\t&-products {\n\t\tmargin: 0;\n\t}\n\n\t&-operator {\n\t\tdisplay: flex;\n\t\tgap: 1em;\n\t\tpadding-left: 0.5em;\n\t\tcolor: $dark-grey;\n\t\tfont-size: 0.9em;\n\n\t\t&-container {\n\t\t\tpadding-left: 0.5em;\n\t\t}\n\n\t\tspan:not(:first-child) {\n\t\t\tmargin-left: -0.7em;\n\t\t}\n\n\t\t&-feedback {\n\t\t\tcolor: $dark-grey;\n\t\t\tfont-size: 0.8em;\n\t\t\tmargin-left: 1em !important;\n\t\t}\n\n\t\t&-selected {\n\t\t\tcolor: black;\n\t\t\tfont-weight: 500;\n\t\t}\n\t}\n\n\t&-title {\n\t\tfont-size: 1.5em;\n\t\tfont-weight: bold;\n\t}\n\n\t&-container {\n\t\tflex: 1;\n\t\tmargin-top: 2em;\n\t\tmargin-inline: 2em;\n\t\tpadding: 2em;\n\t\tborder-radius: 1em;\n\t\tbackground-color: $white;\n\t}\n\n\t&-form {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\n\t\t&-layout {\n\t\t\t@include flex(space-evenly, flex-start);\n\t\t\tflex-wrap: wrap;\n\t\t\tflex-direction: column\n\t\t}\n\t}\n}\n\n.notification-radio-group {\n\t@include flexColumn(flex-start, flex-start);\n\twidth: 100%;\n\n\t.form-radio-group:last-child{\n\t\tdisplay: flex;\n\t\tjustify-content: flex-start;\n\t\talign-items: center;\n\t\tgap: 1em;\n\t\tflex-wrap: wrap;\n\t\toverflow: scroll;\n\t\tmax-height: 8em;\n\t}\n}\n\n.notification-option {\n\t&-label {\n\t\tmargin-right: .5em;\n\t}\n}\n\n.info-badge, .warning-badge, .danger-badge {\n\tbackground-color: rgb(224, 224, 224) !important;\n}\n\n.info-badge{\n\tcolor: rgb(0, 0, 255);\n\tborder: 1px solid rgb(0, 0, 255);\n}\n\n.warning-badge{\n\tcolor: rgb(238, 255, 0);\n\tborder: 1px solid rgb(238, 255, 0);\n}\n\n.danger-badge{\n\tcolor: rgb(255, 8, 0);\n\tborder: 1px solid rgb(255, 8, 0);\n}","@mixin flex($justify-content, $align-items) {\n\tdisplay: flex;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n\n@mixin flexColumn($justify-content, $align-items) {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: $justify-content;\n\talign-items: $align-items;\n}\n","$dark-red: #8f003c;\n$sidebar-selected-color: #c4145d;\n$sidebar-logo-color: #a53363;\n$logo-color: #920942;\n$white: #fff;\n$grey: #f3f6f9;\n$grey2: #e2e5e7;\n$dark-grey: #777776;\n$font-color: #fff;\n$shadow-color: #4e7da2;\n$font: 'Rubik';\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
